<template>
	<div>
		<el-table :data="list" border size="mini" >
			<el-table-column align="center" :label="$t('notice_index.course')">
				<template slot-scope="scope">
					{{lang=='cn'?scope.row.course_name_cn:scope.row.course_name}}&nbsp;&nbsp;
					{{getTime_us(scope.row.start_date,'mmddyyyy')}}-{{getTime_us(scope.row.end_date,'mmddyyyy')}}&nbsp;&nbsp;   
					{{lang=='cn'?scope.row.teacher_name.cn:scope.row.teacher_name.us}}
				</template>
			</el-table-column>
			<el-table-column prop="user_name" align="center" :label="$t('notice_index.tel')"></el-table-column>
			<el-table-column prop="create_time" align="center" :label="$t('notice_index.date')">
				<template slot-scope="scope">{{getTime_us(scope.row.create_time,'mmddyyyy')}}  {{getTime_us(scope.row.create_time,'ampm')}}</template>
			</el-table-column>
			<el-table-column prop="type" align="center" :label="$t('notice_index.type')" >
				<template slot-scope="scope">{{$t('virtual.'+scope.row.type)}}</template>
			</el-table-column>
			<el-table-column prop="is_over" align="center" :label="$t('course_index.status')" >
				<template slot-scope="scope">{{$t('notice_index.status'+scope.row.is_over)}}</template>
			</el-table-column>
			<el-table-column :label="$t('index.operation')" align="center" fixed="right" width="160">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="router_url('/virtual_index',{id:scope.row.course_id,course_type:scope.row.course_type,table:scope.row.type})">{{$t('index.info')}}</el-button>
					<el-button size="mini" type="primary" v-if="scope.row.is_over!=3"  @click="ignore(scope.row)">{{$t('notice_index.ignore')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
	    <div class="page-pagination">
	      <el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
	    </div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			list: [],
			t:'',
			is_over:0,  //0 未处理  1已处理   3已忽略
			pages: {
				page: 1,
				count: 0,
				perpage: 10,
			},
		}
	},

	watch: {
		'$route' (to, from) {
			this.init();
		}
	},
	// 初始事件
	mounted: function () {
		this.t=this.$route.query.t;
		this.init();
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var this_ = this;
			var url = "adminMessageList";
			var datas = {
				page: this_.pages.page,
				num: this_.pages.perpage,
			};
			this.$post(url, datas).then(res => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			}).catch(res => {})
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
		ignore(data){
			var this_ = this;
			var url = "adminMessageIgnore";
			var datas = {
				type:data.type,
				id:data.id,
			};
			this_.$confirm(this_.$t('notice_index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/notice/index.vue